import React,{useEffect,useState} from 'react';
import buildHasuraProvider from 'ra-data-hasura';
import {Admin,Resource} from 'react-admin';
import {InMemoryCache,ApolloClient} from '@apollo/client';
import {createTheme} from '@material-ui/core/styles';
import authProvider from './components/authProvider';
import {BookingCreate,BookingList} from './components/Booking';
import {ReservationList} from './components/Reservation';
import {SlotConfigList} from './components/SlotConfig';
import {EnvInfo} from './components/EnvInfo';
import LoginPage from './components/LoginPage';

const App = () => {
	const myClientWithAuth = new ApolloClient({
		uri: process.env.REACT_APP_HASURA_BACKEND,
		cache: new InMemoryCache(),
		headers: {
			'x-hasura-admin-secret': `DrTxukA2zc9YMKhGe3Dc5ttPJumJpCvN`,
			'content-type': 'application/json'
		},
	});
	const myClientWithoutAuth = new ApolloClient({
		uri: process.env.REACT_APP_HASURA_BACKEND,
		cache: new InMemoryCache(),
	});

	const [resolvedDataProvider,setResolvedDataProvider] = useState();

	useEffect(() => {
		if(!resolvedDataProvider) {
			const p = process.env.REACT_APP_TABLE_PREFIX || '';
			const wrapDp = (dp) => (type, resource, params) => dp(type, `${p}${resource}`, params);
			(async () => {
				buildHasuraProvider({client: myClientWithAuth}).then((dp) => {
					setResolvedDataProvider(() => wrapDp(dp));
				}).catch((e) => {
					buildHasuraProvider({client: myClientWithoutAuth}).then((dp) => setResolvedDataProvider(() => wrapDp(dp)))
				})
			})()
		}
	});


	if(!resolvedDataProvider) {
		return <div>Loading...</div>;
	}

	const myTheme = createTheme({
		overrides: {
			MuiAppBar: {
				colorSecondary: {
					'background-color': process.env.REACT_APP_ENV === 'staging' ? '#c0392b' : '#A08F7C'
				}
			},
			MuiButton: {
				textPrimary: {
					color: '#4C3920'
				}
			},
		}
	})

	return (
		<Admin theme={myTheme} loginPage={LoginPage} authProvider={authProvider} dataProvider={resolvedDataProvider}>
			<Resource options={{label: 'Disponibilità giornaliere'}} name="booking" list={BookingList} create={BookingCreate} />
			<Resource options={{label: 'Prenotazioni'}} name="reservation" list={ReservationList} />
			<Resource options={{label: 'Configurazione Giorni'}} name="slot_config" list={SlotConfigList} />
			{process.env.REACT_APP_ENV === 'staging'
				? <Resource options={{label: '⚠ STAGING'}} name="__env" list={EnvInfo} />
				: <Resource name="__env" />
			}
		</Admin>
	);
};

export default App;
